import { render } from "./ImagePreviewDisable.vue?vue&type=template&id=72d432c3&scoped=true"
import script from "./ImagePreviewDisable.vue?vue&type=script&lang=js"
export * from "./ImagePreviewDisable.vue?vue&type=script&lang=js"

import "./ImagePreviewDisable.vue?vue&type=style&index=0&id=72d432c3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72d432c3"]])

export default __exports__